<span
  class="badge"
  [ngStyle]="overwriteStyle"
  [class.badge-dedicated]="division === 'Dedicated'"
  [class.badge-intermodal]="division === 'Intermodal'"
  [class.badge-instructor]="division === 'Instructor'"
  [class.badge-otr]="division === 'Over the Road'"
  [class.badge-mexico]="division === 'Mexico'"
  [class.badge-other]="division === 'Other'"
  >{{ division }}</span
>
